export const GET_PATIENT_VISIT_REMARKS = 'patientSidePanel/GET_PATIENT_VISIT_REMARKS'
export const GET_PATIENT_VISIT_REMARKS_SUCCESS = 'patientSidePanel/GET_PATIENT_VISIT_REMARKS_SUCCESS'
export const GET_PATIENT_VISIT_REMARKS_ERROR = 'patientSidePanel/GET_PATIENT_VISIT_REMARKS_ERROR'

export const CREATE_PATIENT_VISIT_REMARKS = 'patientSidePanel/CREATE_PATIENT_VISIT_REMARKS'
export const CREATE_PATIENT_VISIT_REMARKS_SUCCESS = 'patientSidePanel/CREATE_PATIENT_VISIT_REMARKS_SUCCESS'
export const CREATE_PATIENT_VISIT_REMARKS_ERROR = 'patientSidePanel/CREATE_PATIENT_VISIT_REMARKS_ERROR'

export const RESET_PATIENT_VISIT_REMARKS_UPDATED = 'patientSidePanel/RESET_PATIENT_VISIT_REMARKS_UPDATED'

export const DISABLE_SIDE_PANEL_LOADING = 'patientSidePanel/DISABLE_SIDE_PANEL_LOADING'

export const CLEAR_SIDE_PANEL = 'patientSidePanel/CLEAR_SIDE_PANEL'
export const CLEAR_ERROR = 'patientSidePanel/CLEAR_ERROR'
